<template>
    <div v-show="isVisible" class="cf-block-title">
        <h2 class="cf-section-title">{{title}}</h2>
    </div>
</template>

<script>


    import { bus } from '../main';
   

    export default {
        name: "BlockTitle",


        data(){
            return {

                isVisible: !this.element.hidden

            }
        },


        props: {
            element: {
                type: Object,
                required: true
            },

            name: {
                type: String,
                required: true
            }                  
            
        },

      

        methods: {



         
        },

        computed: {


            title(){

                return this.element.title;
            }

        },



        created() {

            bus.$on('visibility', (bind, checked ) => {

                bind.split(',').indexOf(this.name) > -1 
                    && (this.isVisible = checked);
            });

           // console.log(this.element);


           // console.log('created renderer')
/*setTimeout(() => {


 this.$parent.$set(this.$parent.form, 'test', 'none')

      }, 3000)*/

          
        }
    }
</script>

<style scoped>

.block-title {
    position:relative;

    
}

.block-title h3 {

    font-size:1.6rem;
}

.block-title hr {
    height:2px;
    opacity: .55;
}

/*.block-title::before {
    content: "";
    position: absolute;
    left: 1rem;
    bottom: 1.2rem;
    height: 3px;
    width: 30px;
    border-radius: 5px;
    background-image: linear-gradient(90deg, rgba(55,219,236,1) 0%, rgba(29,189,205,1) 44%, rgba(0,212,255,1) 100%);
}
*/

</style>


// WEBPACK FOOTER //
// src/components/BlockTitle.vue